// This file was autogenerated from running npm run sync-files.
// DO NOT EDIT THIS FILE DIRECTLY.
// Edit the source file below and then run `npm run sync-files`
// Source: ui/raidboss/data/04-sb/trial/suzaku-ex.ts

import Conditions from '../../../../../resources/conditions';
import Outputs from '../../../../../resources/outputs';
import { Responses } from '../../../../../resources/responses';
import ZoneId from '../../../../../resources/zone_id';
import { RaidbossData } from '../../../../../types/data';
import { TriggerSet } from '../../../../../types/trigger';

// TODO: Remind user to bait exactly one bird with Rekindle.
// TODO: MapEffect out the Hotspot patterns
// TODO: Figure out Close-Quarter Crescendo
// TODO: Call Incandescent Interlude towers

export type Data = RaidbossData;

// Suzaku Unreal
const triggerSet: TriggerSet<Data> = {
  id: 'HellsKierUnreal',
  zoneId: ZoneId.HellsKierUnreal,
  timelineFile: 'suzaku-un.txt',
  triggers: [
    {
      id: 'SuzakuUn Screams Of The Damned',
      type: 'StartsUsing',
      netRegex: { id: 'A7FC', source: 'Suzaku', capture: false },
      response: Responses.aoe(),
    },
    {
      id: 'SuzakuUn Rekindle',
      type: 'HeadMarker',
      netRegex: { id: '008B', capture: true },
      condition: Conditions.targetIsYou(),
      response: Responses.spread(),
    },
    {
      id: 'SuzakuUn Cremate',
      type: 'StartsUsing',
      netRegex: { id: 'A7FB', source: 'Suzaku', capture: true },
      response: Responses.tankBuster(),
    },
    {
      id: 'SuzakuUn Southron Star',
      type: 'StartsUsing',
      netRegex: { id: 'A807', source: 'Suzaku', capture: false },
      response: Responses.aoe(),
    },
    { // Non-capturing because her initial castbar is self-targeted.
      id: 'SuzakuUn Phantom Flurry Buster',
      type: 'StartsUsing',
      netRegex: { id: 'A804', source: 'Suzaku', capture: false },
      alertText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: Outputs.tankBuster,
      },
    },
    {
      id: 'SuzakuUn Phantom Flurry Behind',
      type: 'Ability',
      netRegex: { id: 'A804', source: 'Suzaku', capture: false },
      response: Responses.getBehind(),
    },
    {
      id: 'SuzakuUn Scathing Net',
      type: 'HeadMarker',
      netRegex: { id: '00A1', capture: true },
      response: Responses.stackMarkerOn(),
    },
    {
      id: 'SuzakuUn Mesmerizing Melody',
      type: 'StartsUsing',
      netRegex: { id: 'A802', source: 'Suzaku', capture: false },
      response: Responses.getOut(),
    },
    {
      id: 'SuzakuUn Ruthless Refrain',
      type: 'StartsUsing',
      netRegex: { id: 'A803', source: 'Suzaku', capture: false },
      response: Responses.getIn(),
    },
  ],
  timelineReplace: [
    {
      'locale': 'de',
      'replaceSync': {
        'Tenzen': 'Tenzen',
        'Scarlet Tail Feather': 'Schwanzfeder',
        'Suzaku': 'Suzaku',
      },
      'replaceText': {
        'Close-Quarter Crescendo': 'Puppencrescendo',
        'Cremate': 'Einäschern',
        'Eternal Flame': 'Ewige Flamme',
        'Fleeting Summer': 'Vergänglicher Sommer',
        'Hotspot': 'Hitzestau',
        'Incandescent Interlude': 'Glühendes Intermezzo',
        'Mesmerizing Melody': 'Bezaubernde Melodie',
        'Pay The Piper': 'Lied des Fängers',
        'Phantom Flurry': 'Phantomhast',
        'Phantom Half': 'Phantom Hälfte',
        'Phoenix Down': 'Phönixsturz',
        'Rekindle': 'Wiederaufleben',
        'Rout': 'Kolossgalopp',
        'Ruthless Refrain': 'Rabiater Refrain',
        'Ruthless/Mesmerizing': 'Refrain/Melodie',
        'Scarlet Fever': 'Feuertod',
        'Scarlet Hymn': 'Zinnoberhymne',
        'Scathing Net': 'Vernichtendes Netz',
        'Screams Of The Damned': 'Schreie der Verdammten',
        'Southron Star': 'Stern des Südens',
        'Well Of Flame': 'Flammenbrunnen',
        'Wing And A Prayer': 'Letztes Gebet',
      },
    },
    {
      'locale': 'fr',
      'replaceSync': {
        'Tenzen': 'Tenzen',
        'Scarlet Tail Feather': 'plume de queue de Suzaku',
        'Suzaku': 'Suzaku',
      },
      'replaceText': {
        'Close-Quarter Crescendo': 'Mélopée fantoche',
        'Cremate': 'Crématorium',
        'Eternal Flame': 'Flamme éternelle',
        'Fleeting Summer': 'Ailes vermillon',
        'Hotspot': 'Couleurs',
        'Incandescent Interlude': 'Mélopée incandescente',
        'Mesmerizing Melody': 'Mélodie hypnotique',
        'Pay The Piper': 'Poème fantoche',
        'Phantom Flurry': 'Frénésie spectrale',
        'Phantom Half': 'Frénésie - Moitié de plateau',
        'Phoenix Down': 'Queue de phénix',
        'Rekindle': 'Ravivement',
        'Rout': 'Irruption',
        'Ruthless/Mesmerizing': 'Refrain/Mélodie',
        'Ruthless Refrain': 'Refrain impitoyable',
        'Scarlet Fever': 'Fièvre écarlate',
        'Scarlet Hymn': 'Hymne vermillon',
        'Scathing Net': 'Étoiles des enfers',
        'Screams Of The Damned': 'Cris des damnés',
        'Southron Star': 'Étoile australe',
        'Well Of Flame': 'Puits ardent',
        'Wing And A Prayer': 'Prière de pennes',
      },
    },
    {
      'locale': 'ja',
      'replaceSync': {
        'Tenzen': 'テンゼン',
        'Scarlet Tail Feather': '朱雀の尾羽根',
        'Suzaku': '朱雀',
      },
      'replaceText': {
        'Close-Quarter Crescendo': '傀儡の調べ',
        'Cremate': '赤熱撃',
        'Eternal Flame': '再生の大火',
        'Fleeting Summer': '翼宿撃',
        'Hotspot': '紅蓮炎',
        'Incandescent Interlude': '灼熱の調べ',
        'Mesmerizing Melody': '誘引の旋律',
        'Pay The Piper': '傀儡詩',
        'Phantom Flurry': '鬼宿脚',
        'Phantom Half': '鬼宿脚 (フィールド半分)',
        'Phoenix Down': '再生の羽根',
        'Rekindle': '再生の炎',
        'Rout': '猛進',
        'Ruthless Refrain': '拒絶の旋律',
        'Ruthless/Mesmerizing': '拒絶/誘引',
        'Scarlet Fever': '焼滅天火',
        'Scarlet Hymn': '朱の旋律',
        'Scathing Net': '張宿業火',
        'Screams Of The Damned': '叫喚地獄',
        'Southron Star': '星宿波',
        'Well Of Flame': '井宿焔',
        'Wing And A Prayer': '再生の神通力',
      },
    },
    {
      'locale': 'cn',
      'replaceSync': {
        'Tenzen': '典膳',
        'Scarlet Tail Feather': '朱雀的尾羽',
        'Suzaku': '朱雀',
      },
      'replaceText': {
        'Close-Quarter Crescendo': '傀儡旋律',
        'Cremate': '赤热击',
        'Eternal Flame': '苏生大火',
        'Fleeting Summer': '翼宿击',
        'Hotspot': '红莲炎',
        'Incandescent Interlude': '灼热旋律',
        'Mesmerizing Melody': '引诱旋律',
        'Pay The Piper': '傀儡诗',
        'Phantom Flurry': '鬼宿脚',
        'Phantom Half': '半场AOE',
        'Phoenix Down': '苏生之羽',
        'Rekindle': '苏生之炎',
        'Rout': '猛进',
        'Ruthless Refrain': '拒绝旋律',
        'Ruthless/Mesmerizing': '拒绝/引诱',
        'Scarlet Fever': '灭尽天火',
        'Scarlet Hymn': '朱红旋律',
        'Scathing Net': '张宿业火',
        'Screams Of The Damned': '叫唤地狱',
        'Southron Star': '星宿波',
        'Well Of Flame': '井宿焰',
        'Wing And A Prayer': '苏生神通力',
      },
    },
    {
      'locale': 'tc',
      'replaceSync': {
        'Tenzen': '典膳',
        'Scarlet Tail Feather': '朱雀的尾羽',
        'Suzaku': '朱雀',
      },
      'replaceText': {
        'Close-Quarter Crescendo': '傀儡旋律',
        'Cremate': '赤熱擊',
        'Eternal Flame': '蘇生大火',
        'Fleeting Summer': '翼宿擊',
        'Hotspot': '紅蓮炎',
        'Incandescent Interlude': '灼熱旋律',
        'Mesmerizing Melody': '引誘旋律',
        'Pay The Piper': '傀儡詩',
        'Phantom Flurry': '鬼宿腳',
        'Phantom Half': '鬼宿腳',
        'Phoenix Down': '蘇生之羽',
        'Rekindle': '蘇生之炎',
        'Rout': '猛進',
        'Ruthless Refrain': '拒絕旋律',
        'Ruthless/Mesmerizing': '拒絕/引誘',
        'Scarlet Fever': '燃燼天火',
        'Scarlet Hymn': '朱紅旋律',
        'Scathing Net': '張宿業火',
        'Screams Of The Damned': '叫喚地獄',
        'Southron Star': '星宿波',
        'Well Of Flame': '井宿焰',
        'Wing And A Prayer': '蘇生神通力',
      },
    },
    {
      'locale': 'ko',
      'replaceSync': {
        'Tenzen': '텐젠',
        'Scarlet Tail Feather': '주작의 꽁지깃',
        'Suzaku': '주작',
      },
      'replaceText': {
        'Close-Quarter Crescendo': '꼭두각시의 음률',
        'Cremate': '적열격',
        'Eternal Flame': '재생의 불길',
        'Fleeting Summer': '익수격',
        'Hotspot': '홍련염',
        'Incandescent Interlude': '작열의 음률',
        'Mesmerizing Melody': '유인의 선율',
        'Pay The Piper': '꼭두각시의 노래',
        'Phantom Flurry': '귀수각',
        'Phantom Half': '전방 피하기',
        'Phoenix Down': '재생의 깃털',
        'Rekindle': '재생의 불꽃',
        'Rout': '맹진',
        'Ruthless Refrain': '거절의 선율',
        'Ruthless/Mesmerizing': '거절/유인의 선율',
        'Scarlet Fever': '소멸천화',
        'Scarlet Hymn': '붉은 선율',
        'Scathing Net': '장수업화',
        'Screams Of The Damned': '규환지옥',
        'Southron Star': '성수파',
        'Well Of Flame': '정수염',
        'Wing And A Prayer': '재생의 신통력',
      },
    },
  ],
};

export default triggerSet;
